/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Icon } from '@betrybe/ada-react';

type propsType = {
  accordionChecked: boolean;
  accordionError: boolean;
};

export const textColor = (props: propsType) => {
  const { accordionChecked, accordionError } = props;
  if (accordionChecked && !accordionError) {
    return 'text-green-300';
  }
  if (accordionError) {
    return 'text-coral-900';
  }
  return '';
};

export const hasIcon = (props: propsType) => {
  const { accordionChecked, accordionError } = props;
  if (accordionChecked && !accordionError) {
    return (
      <Icon
        name="check_circle"
        className={`${textColor({ accordionChecked, accordionError })}`}
      />
    );
  }
  if (accordionError) {
    return (
      <Icon
        name="error_circle"
        className={`${textColor({ accordionChecked, accordionError })}`}
      />
    );
  }
  return <></>;
};

export const color = (props: propsType) => {
  const { accordionChecked, accordionError } = props;
  if (accordionChecked && !accordionError) {
    return 'green';
  }
  if (accordionError) {
    return 'coral';
  }
  return 'purple';
};
